import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cdb1cd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Modifier")

import {ref, watch} from "vue";
import FormTemplate from '@/components/FormTemplate.vue';
import Button from '@/components/Button.vue';
import Modale from '@/modales/Modale.vue';
import Loader from '@/components/Loader.vue';

import {storeUser} from "@/stores/user";
import {storeSystem} from "@/stores/system";


export default /*#__PURE__*/_defineComponent({
  props: {
  userToEdit: { type: Object, default: {} },
  open: { type: Boolean, default: false },
},
  emits: ['close', 'edit'],
  setup(__props, { emit }) {

const props = __props




//V-MODEL
const model = ref([
  { type: "text", placeholder: "Nom", field: "lastname", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig, isValid: false }] },
  { type: "text", placeholder: "Prénom", field: "firstname", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig, isValid: false }] },
  { type: "email", placeholder: "Email", field: "email", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig, isValid: false }] },
]);

const _storeUser = storeUser();
const _storeSystem = storeSystem();

const processEdit = ref(false);
const editUser = () => {
  processEdit.value = true;
  _storeUser.editUser(props.userToEdit.id, model.value[1].value, model.value[0].value, model.value[2].value).then((response) => {
    _storeSystem.addInfoTag({id: '', type: 'success', text: "Utilisateur modifié"});
    processEdit.value = false;
    emit('edit');
  });
};

watch(() => props.open, (newValue) => {
  if (newValue) {
    model.value[0].value = props.userToEdit.lastname;
    model.value[1].value = props.userToEdit.firstname;
    model.value[2].value = props.userToEdit.email;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modale, {
    title: "Modifier un collaborateur",
    open: __props.open,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (processEdit.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        class: "ef-editUser",
        onSubmit: _withModifiers(editUser, ["prevent"])
      }, [
        _createVNode(FormTemplate, { inputs: model.value }, {
          default: _withCtx(({ errorCount }) => [
            _createVNode(Button, {
              disabled: errorCount !== 0,
              type: "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]),
          _: 1
        }, 8, ["inputs"])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})